export default __webpack_public_path__ + "static/16-755014df2a475ad5041d80b46d7efb39.jpg";